<script>

export default  {
  name: 'lgyesenia',
data () {
  return {
    contactoyes:''
  }
  },
  mounted() {
    if(this.$device.mobile){
      this.contactoyes = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/infoyeseniamobile.png'
    }else{
      this.contactoyes = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/infoyeseniaweb.png'

    }
  }

}
</script>

<template>
<v-app>
  <v-main class="pa-0"  style="background-color: #F0ECE4;">
    <v-app-bar
        app
        absolute
        color="#F0ECE4"
        :elevation="2"
    >
      <v-row justify="center" align="center">
        <v-col cols="11" xl="9" lg="9">
          <router-link :to="{ name: 'lgportada'}">
            <v-img
                alt="Lg Logo"

                contain
                min-width="100"
                src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/logo.png"
                width="100"
            /></router-link>
        </v-col>
      </v-row>


    </v-app-bar>
    <v-container fluid  class="pa-0"  style="margin-top: 120px;">
    <v-row justify="center" align="center">

      <v-col cols="8">
        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/yessresumen.png">
        </v-img>
      </v-col>
    </v-row>

      <v-row justify="center" align="center">
      <v-col cols="10">
        <hr/>
      </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="6">
             <h1 style="color: #A50035; text-align: center; "> Portafolio</h1>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="8">
          <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/portafolio.png">
          </v-img>
        </v-col>
      </v-row>
      <v-row align="stretch" class="mb-12">
        <v-col cols="12" lg="6" xl="6" md="12" style="text-align: right;" class="d-flex flex-column">
          <v-row justify="end" align="center">
          <v-col cols="2">
          </v-col></v-row>

        </v-col>
        <v-col class="d-flex flex-column" cols="6">
            <v-row>
              <v-col cols="12" lg="8" xl="8" md="6" sm="12" >
                 <v-img :src="contactoyes" />

              </v-col>
            </v-row>
        </v-col>
      </v-row>

    </v-container>
  </v-main>
</v-app>
</template>

<style >
.grecaptcha-badge{
  display: none;
}
</style>